import React from 'react';
import { Link } from 'gatsby';

import logoGray from '../../../content/assets/logo-gray.svg';
import footerStyle from './footer.module.scss';

class FooterComponent extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <footer className={footerStyle.footer}>
                <div className={footerStyle.footer__inner}>
                    <Link
                        className={footerStyle.footer__inner_logo}
                        to={'/'}>
                        <img src={logoGray} alt="logo" />
                    </Link>
                    <div className={footerStyle.footer__inner_category}>
                        <div className={footerStyle.footer__inner_category_title}>Собаки</div>
                        <div className={footerStyle.footer__inner_category_list}>
                            {
                                this.props.availableCategories.dogs.map((c) => {
                                    return <Link className={footerStyle.footer__inner_category_list_item} key={c.value} to={`/category/${c.value}`}>{c.name}</Link>
                                })
                            }
                        </div>
                    </div>
                    <div className={footerStyle.footer__inner_category}>
                        <div className={footerStyle.footer__inner_category_title}>Коти</div>
                        <div className={footerStyle.footer__inner_category_list}>
                            {
                                this.props.availableCategories.cats.map((c) => {
                                    return <Link className={footerStyle.footer__inner_category_list_item} key={c.value} to={`/category/${c.value}`}>{c.name}</Link>
                                })
                            }
                        </div>
                    </div>
                </div>
            </footer>
        )
    }
}

export default ({ availableCategories }) => {

    return <FooterComponent availableCategories={availableCategories} />
}